import firebase from 'firebase/app'
import 'firebase/database'
import { Marker } from 'types/markers'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

function getUserId(articleId: number) {
  const userId = window.localStorage.getItem(articleId + '-userId')
  if (userId) {
    return userId
  } else {
    console.warn('L’utilisateur n’a pas été trouvé pas')
    return false
  }
}

export function submitPlace(marker: Marker, articleId: number) {
  console.log('Save new marker:', marker, 'article:', articleId)
  const userId = getUserId(articleId)
  if (userId && typeof userId === 'string') {
    const suggestedMarkerRef = firebase.database().ref('suggested_markers/')
    marker.userId = userId
    marker.ts = firebase.database.ServerValue.TIMESTAMP
    marker.publication = parseHostname().publicationName
    console.log('Sending marker', marker)
    const newId = suggestedMarkerRef.push(marker).getKey()
    suggestedMarkerRef.child(newId).update({ markerId: newId })
  } else {
    console.warn('No userId was found.')
  }
}

export function submitChanges(marker: Marker, articleId: number) {
  /*
    principe:
    - on crée un clone du marker dans suggested_markers
    - si ce clone est accepté, le marker d'origine est supprimé
    - on utilise une propriété qui flagge le fait que c'est un changement
  */
  console.log('Submitting changes for marker', marker.markerId)
  const userId = getUserId(articleId)
  if (userId && typeof userId === 'string') {
    const suggestedMarkerRef = firebase
      .database()
      .ref('suggested_markers/' + marker.markerId)
    marker.updateUserId = userId
    marker.changeRequest = true
    marker.updateTs = firebase.database.ServerValue.TIMESTAMP
    console.log('Sending marker update', marker)
    suggestedMarkerRef.set(marker)
  } else {
    console.warn('No userId was found.')
  }
}

// Edit an already published marker
export function adminEditMarker(marker: Marker, adminUsername: string) {
  console.log('Edit marker', marker, 'admin:', adminUsername)
}

// Edit and publish a suggested marker
export function adminPublishMarker(marker: Marker, adminUsername: string) {
  console.log('Admin Edit -- model')
  // TODO: on doit pouvoir recuperer (et editer) ce nouveau marqueur
  const suggestedMarkerRef = firebase
    .database()
    .ref('suggested_markers/' + marker.markerId)
  const markerRef = firebase.database().ref('markers/')

  marker.needsReview = false
  marker.reviewer = adminUsername

  try {
    // Send form data to markers, set id as markerId
    const newId = markerRef.push(marker).getKey()
    console.log('New id is', newId)
    console.log(marker)
    markerRef.child(newId).update({ markerId: newId })
    // Delete from suggested markers
    suggestedMarkerRef.remove()
  } catch (err) {
    console.log(err.message)
  }
}

export function adminValidateMarker(markerId: string, adminUsername: string) {
  const suggestRef = firebase.database().ref('suggested_markers/' + markerId)
  const markerRef = firebase.database().ref('markers/')

  try {
    suggestRef.once('value').then(function(snapshot) {
      const markerData = snapshot.val()
      console.log(snapshot.val())
      if (markerData) {
        markerData.needsReview = false
        markerData.reviewer = adminUsername
      } else {
        console.log('There is no retrieved data!')
      }
      // Copy to markers, set id as markerId
      const newId = markerRef.push(markerData).getKey()
      markerRef.child(newId).update({ markerId: newId })
      // Delete from suggested markers
      suggestRef.remove()
    })
  } catch (err) {
    console.log(err.message)
  }
}

export function adminDeletePublishedMarker(markerId: string) {
  const suggestRef = firebase.database().ref('markers/' + markerId)
  suggestRef.remove()
}

export function adminDisableMarker(markerId: string, adminUsername: string) {
  console.log('Disabling marker', markerId)
  const markerRef = firebase.database().ref('markers/' + markerId)

  try {
    markerRef.once('value').then(function(snapshot) {
      const markerData = snapshot.val()
      console.log(markerData)
      if (markerData) {
        markerData.disabled = true
        markerData.reviewer = adminUsername
        markerRef.set(markerData)
      } else {
        console.warn('There is no retrieved data!')
      }
    })
  } catch (err) {
    console.log(err.message)
  }
}

export function adminDeleteSuggestedMarker(markerId: string) {
  const suggestRef = firebase.database().ref('suggested_markers/' + markerId)
  suggestRef.remove()
}

export function adminDeleteMarker(markerId: string) {
  const suggestRef = firebase.database().ref('markers/' + markerId)
  suggestRef.remove()
}

export function flagMarker(
  markerId: string,
  userId: string,
  handleSent: (success: boolean) => void
) {
  console.log('Flagging marker', markerId, '– user:', userId)
  firebase
    .database()
    .ref('markers/' + markerId + '/flag/')
    .child(userId)
    .set({
      flag: true,
      ts: firebase.database.ServerValue.TIMESTAMP
    })
    .then(() => {
      handleSent(true)
    })
    .catch(error => {
      console.warn(error)
      handleSent(false)
    })
}

// dessous: vieux trucs
/*
export function addSuggestedMarker(jsondata){
  firebase
    .database()
    .ref('suggestedMarkers/' + markerId + '/' + userId + '/' + vote)
      .push({
        publication: parseHostname().publicationName
      })
  console.log('Sent to firebase')
}

export function addVote(markerId: string, userId: string, direction: string){
  firebase
    .database()
    .ref('votes/' + markerId)
    .child(userId)
    .set({
      vote: direction === 'up' ? 1 : -1, // nb: utiliser increment / decrement?
      ts: firebase.database.ServerValue.TIMESTAMP // time since the Unix epoch, in milliseconds
    })
  console.log('Sent to firebase as child')
}

export function getVotes(markerId: string){
  const ref = firebase
    .database()
    .ref('votes/' + markerId)

    ref.once('value', (snapshot) => {
      console.log(snapshot)
    })
}

export function init() {
    // Init Firebase
    const config = {
      apiKey: 'AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA',
      authDomain: 'wch-interactive.firebaseapp.com',
      databaseURL: 'https://bons-plans.europe-west1.firebasedatabase.app/',
      projectId: 'wch-interactive',
      storageBucket: 'wch-interactive.appspot.com',
      messagingSenderId: '717470310087',
      appId: '1:717470310087:web:c2fb9c194a203ebfee68e2',
      measurementId: 'G-0GB2H3HTS8'
    }
    if (!firebase.apps.length) {
      firebase.initializeApp(config)
    }
  }
}
*/
